/// <amd-module name="Wit/WorkItemFormMarkdown/TablesPlugin" />
import * as TurndownService from "turndown";

// This is altered code from turndown-plugin-gfm plugin with typescript and Excel + Word tables support.
// We couldn't use the plugin directly as it has problems with converting Excel and Word tables.

const rules: { [key: string]: TurndownService.Rule } = {};

rules.tableCell = {
    filter: ["th", "td"],
    replacement: function (content, node) {
        return cell(content, node);
    }
};

rules.tableParagraph = {
    filter: "p",
    replacement: function (content, node) {
        const parentNode = node.parentNode;
        if (parentNode?.nodeName === "TD" || parentNode?.nodeName === "TH") {
            return content + "<br>";
        } else {
            return "\n" + content + "\n";
        }
    }
};

rules.tableRow = {
    filter: "tr",
    replacement: function (content, node) {
        let borderCells = "";
        let alignMap = { left: ":--", right: "--:", center: ":-:" };

        if (isHeadingRow(node)) {
            for (let i = 0; i < node.childNodes.length; i++) {
                let border = "---";
                let childNode = node.childNodes[i] as any;
                let align: "left" | "right" | "center" = (childNode.getAttribute("align") || "").toLowerCase();

                if (align) border = alignMap[align] || border;

                borderCells += cell(border, childNode);
            }
        }
        return "\n" + content + (borderCells ? "\n" + borderCells : "");
    }
};

rules.tableSection = {
    filter: ["thead", "tbody", "tfoot", "table"],
    replacement: function (content) {
        return content;
    }
};

function isHeadingRow(tr: TurndownService.Node | null) {
    const parentNode = tr?.parentNode;
    return parentNode
        ? parentNode.nodeName === "THEAD" || (parentNode.firstChild === tr && (parentNode.nodeName === "TABLE" || isFirstTbody(parentNode)))
        : false;
}

function isFirstTbody(element: ParentNode | null) {
    const previousSibling = element?.previousSibling;
    return (
        element?.nodeName === "TBODY" &&
        (!previousSibling ||
            ((previousSibling.nodeName === "THEAD" || previousSibling.nodeName === "COLGROUP") && /^\s*$/i.test(previousSibling.textContent ?? "")))
    );
}

function cell(content: string, node: TurndownService.Node) {
    let index = Array.prototype.indexOf.call(node.parentNode?.childNodes, node);
    let prefix = " ";
    if (index === 0) prefix = "| ";
    return prefix + content.replace(/\n/g, "<br>") + " |";
}

export function tables(turndownService: TurndownService) {
    turndownService.remove("style");
    for (let key in rules) {
        turndownService.addRule(key, rules[key]);
    }
}
